module.exports = __webpack_public_path__ + "static/cowork-338f1415dd676a20cfe8cfd237b5fa1c.svg";